import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
  Checkbox,
  TextField,
  MenuItem,
  Grid,
  Switch,
  Tooltip,
} from "@mui/material";

function TikTokApprovalPage() {
  const { ref, code } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [postData, setPostData] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [contentInfo, setContentInfo] = useState({});
  const [comment, setComment] = useState(false);
  const [duet, setDuet] = useState(false);
  const [stitch, setStitch] = useState(false);
  const [caption, setCaption] = useState(null);
  const [privacyLevel, setPrivacyLevel] = useState(null);
  const [tosAgree, setTosAgree] = useState(false);
  const [disclose, setDisclose] = useState(false);
  const [brandedContent, setBrandedContent] = useState(false);
  const [personalContent, setPersonalContent] = useState(false);
  const [statusDialog, setStatusDialog] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`sm/tiktok/approval/${ref}/${code}/init.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPostData(result.data.data.postData);
            setCaption(result.data.data.postData.title);
            setAccessToken(result.data.data.accessToken);
            setUserInfo(result.data.data.userInfo);
            setContentInfo(result.data.data.contentInfo);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function executePost() {
    if (privacyLevel === null) {
      alert(`Please select who can see this post.`);
      return;
    }

    if (disclose) {
      if (!personalContent && !brandedContent) {
        alert(
          `You need to indicate if your content promotes yourself, a third party, or both.`,
        );
        return;
      }
    }

    if (tosAgree === false) {
      alert(`Please agree to TikTok's content and usage policies.`);
      return;
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      access_token: accessToken,
      caption: `${caption}`,
      privacy_level: privacyLevel,
      comment_allow: comment,
      duet_allow: duet,
      stitch_allow: stitch,
    };

    // console.log(json);

    await axios
      .post("sm/tiktok/approval/post", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSeverity("success");
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  //   useEffect(() => {
  //     if (brandedContent) {
  //       if (privacyLevel === "SELF_ONLY") {
  //         setPrivacyLevel("PUBLIC_TO_EVERYONE");
  //       }
  //       alert(
  //         "By selecting Branded Content, you cannot post your video as SELF_ONLY. Your privacy settings will be changed to PUBLIC_TO_EVERYONE"
  //       );
  //     }
  //   }, [brandedContent]);

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Dialog open={statusDialog}>
        <DialogContent>
          <Box align="center">
            <Box mb={3}>
              <Typography variant="h6">Post Successful!</Typography>
            </Box>
            <Icon color="success">check</Icon>
            <Box mt={3}>
              <Typography variant="subtitle2">
                Your post has been submitted. This may take a few minutes to
                reflect in your timeline.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {postData !== null ? (
        <Box
          mt={10}
          sx={{ width: "100%", maxWidth: "800px", margin: "25px auto" }}
        >
          <Box>
            <h3>API INFORMATION RETURNED</h3>
            <div>
              <h4>User Info</h4>
              <pre>{JSON.stringify(userInfo, null, 4)}</pre>
            </div>
            <Box>
              <h4>Content Info</h4>
              <pre>{JSON.stringify(contentInfo, null, 4)}</pre>
            </Box>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <Box mt={1} align="center">
                {postData.media_type === "VIDEO" ? (
                  <Box
                    sx={{
                      padding: "10px",
                      background: "#D3D3D3",
                      webkitBorderRadius: "15px",
                      borderRadius: "15px",
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      title={postData.title}
                      type="text/html"
                      width="100%"
                      height="480"
                      src={`${postData.media}`}
                      frameBorder="0"
                      allowFullScreen
                    />
                  </Box>
                ) : (
                  <Paper elevation={0}>
                    <Box
                      p={2}
                      sx={{
                        padding: "10px",
                        background: "#D3D3D3",
                        webkitBorderRadius: "15px",
                        borderRadius: "15px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={`${postData.media}`}
                        alt={postData.title}
                        width="100%"
                        // width="320px"
                      />
                    </Box>
                  </Paper>
                )}
              </Box>
              <Box mt={2}>
                <Typography mt={3} variant="div">
                  Video Duration Check passed: 31 secs is less than{" "}
                  {contentInfo.max_video_post_duration_sec} seconds
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Paper>
                <Box p={2}>
                  <Typography mb={3}>
                    <img src={contentInfo.creator_avatar_url} width={48} />
                  </Typography>
                  <Typography mb={3}>
                    Creator Name: {contentInfo.creator_nickname}
                  </Typography>
                  <Box mt={4}>
                    <TextField
                      fullWidth
                      multiline
                      label="Caption"
                      placeholder={caption}
                      onChange={(e) => setCaption(e.target.value)}
                    />
                  </Box>

                  <Box mt={4}>
                    <TextField
                      label="Who can see this?"
                      fullWidth
                      select
                      value={privacyLevel}
                      onChange={(e) => {
                        if (e.target.value === "SELF_ONLY") {
                          if (brandedContent === true) {
                            alert(
                              "Videos with visibility set to SELF_ONLY can not be posted as Branded Content. Your privacy settings will be changed.",
                            );
                            setBrandedContent(false);
                          }
                        }

                        setPrivacyLevel(e.target.value);
                      }}
                    >
                      {contentInfo.privacy_level_options.map((row) => (
                        <MenuItem value={row}>{row}</MenuItem>
                      ))}
                    </TextField>
                  </Box>
                  <Box mt={5}>
                    <Typography>Allow users to</Typography>
                    <List>
                      <ListItem>
                        <Checkbox
                          disabled={contentInfo.comment_disabled ? true : false}
                          onChange={(e) => setComment(e.target.checked)}
                        />{" "}
                        Comment
                      </ListItem>
                      <ListItem>
                        <Checkbox
                          disabled={contentInfo.duet_disabled ? true : false}
                          onChange={(e) => setDuet(e.target.checked)}
                        />{" "}
                        Duet
                      </ListItem>
                      <ListItem>
                        <Checkbox
                          disabled={contentInfo.stitch_disabled ? true : false}
                          onChange={(e) => setStitch(e.target.checked)}
                        />{" "}
                        Stitch
                      </ListItem>
                    </List>
                  </Box>
                  <Box mt={5}>
                    <Box display="flex" justifyContent="space-between" mb={1}>
                      <Typography fontWeight={600}>
                        Disclose video content
                      </Typography>
                      <Box mt={-1}>
                        <Switch
                          onChange={(e) => {
                            setDisclose(e.target.checked);
                            if (!e.target.checked) {
                              setPersonalContent(false);
                              setBrandedContent(false);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                    <Typography fontSize={13}>
                      Turn on to disclose that this video promotes goods or
                      services in exchange for something of value. Your video
                      could promote yourself, a third party or both.
                    </Typography>
                    {disclose ? (
                      <Box mt={3}>
                        <Box mb={3}>
                          <Checkbox
                            onChange={(e) =>
                              setPersonalContent(e.target.checked)
                            }
                          />
                          <b>Your brand</b>
                          <Typography fontSize={14}>
                            You are promoting yourself or your business. This
                            video will be classified as <b>Brand Organic</b>
                          </Typography>
                        </Box>
                        <Box>
                          <Checkbox
                            checked={brandedContent}
                            onChange={(e) => {
                              setBrandedContent(e.target.checked);
                              if (e.target.checked) {
                                if (privacyLevel === "SELF_ONLY") {
                                  setPrivacyLevel("PUBLIC_TO_EVERYONE");
                                }
                                alert(
                                  "By selecting Branded Content, you cannot post your video as SELF_ONLY. Your visibility settings will be changed to PUBLIC_TO_EVERYONE",
                                );
                              }
                            }}
                          />
                          <b>Branded Content</b>
                          <Typography fontSize={14}>
                            You are promoting another brand or third party. This
                            video will be classified as <b>Branded Content</b>
                          </Typography>
                        </Box>
                        {personalContent || brandedContent ? (
                          <Box mt={2}>
                            <Alert severity="warning">
                              {personalContent && brandedContent ? (
                                "Your video will be labeled as 'Paid partnership'. This cannot be changed once your video is posted."
                              ) : (
                                <>
                                  {personalContent && !brandedContent ? (
                                    "Your video will be labeled as 'Promotional content'. This cannot be changed once your video is posted."
                                  ) : (
                                    <>
                                      {brandedContent && !personalContent
                                        ? "Your video will be labeled as 'Paid partnership'. This cannot be changed once your video is posted."
                                        : ""}
                                    </>
                                  )}
                                </>
                              )}
                            </Alert>
                          </Box>
                        ) : (
                          <> </>
                        )}
                      </Box>
                    ) : (
                      <> </>
                    )}
                    <Box mt={5}>
                      <Box display="flex" alignItems="center" ml={-1}>
                        <Checkbox
                          checked={tosAgree}
                          onChange={(e) => {
                            setTosAgree(e.target.checked);
                          }}
                        />
                        <Typography
                          variant="subtitle2"
                          fontSize={14}
                          fontWeight={400}
                        >
                          {personalContent && brandedContent ? (
                            <>
                              By posting, you agree to TikTok's{" "}
                              <a href="https://www.tiktok.com/legal/page/global/bc-policy/en">
                                <i>Branded Content Policy</i>
                              </a>{" "}
                              and{" "}
                              <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">
                                <i>Music Usage Confirmation</i>
                              </a>
                            </>
                          ) : (
                            <>
                              {personalContent && !brandedContent ? (
                                <>
                                  By posting, you agree to TikTok's{" "}
                                  <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">
                                    <i>Music Usage Confirmation</i>
                                  </a>
                                </>
                              ) : (
                                <>
                                  {brandedContent && !personalContent ? (
                                    <>
                                      By posting, you agree to TikTok's{" "}
                                      <a href="https://www.tiktok.com/legal/page/global/bc-policy/en">
                                        <i>Branded Content Policy</i>
                                      </a>{" "}
                                      and{" "}
                                      <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">
                                        <i>Music Usage Confirmation</i>
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      By posting, you agree to TikTok's{" "}
                                      <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">
                                        <i>Music Usage Confirmation</i>
                                      </a>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                          .
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box mt={5} align="center">
                    {disclose ? (
                      <>
                        {!personalContent && !brandedContent ? (
                          <Tooltip
                            title="You need to indicate if this content promotes
                            yourself, a third party or both."
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={() =>
                                alert(
                                  "You need to indicate if this content promotes yourself, a third party or both.",
                                )
                              }
                            >
                              POST CONTENT
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button
                            fullWidth
                            variant="contained"
                            onClick={() => executePost()}
                          >
                            POST CONTENT
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => executePost()}
                      >
                        POST CONTENT
                      </Button>
                    )}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <> </>
      )}
    </>
  );
}

export default TikTokApprovalPage;
